module.exports = __webpack_public_path__ + "static/media/uniswapLight.55cff9e8.png";